// extracted by mini-css-extract-plugin
export default {"departments":"kG-z","departmentHeading":"lG-z","departmentSection":"mG-z","departmentName":"nG-z","departmentLink":"oG-z","expandIcon":"pG-z"};